<template>
  <div>
    <template v-if="type === 'select'">
      <select @change="onChange" v-model="task.sub_status" class="form-control">
        <option v-for="s in statuses" :value="s.id">{{ s.title }}</option>
      </select>
    </template>
    <template v-if="type === 'display'">
      <span class="badge badge-primary">{{ statuses[task.sub_status]?.title }}</span>
    </template>
  </div>
</template>

<script>
export default {
  props: ['task', 'onChange', 'type'],
  data() {
    return {
      statuses: {
        1: {id: 1, title: 'пауза'},
        2: {id: 2, title: 'недозвон'},
        3: {id: 3, title: 'ответ на е-мейл'},
        4: {id: 4, title: 'отсутствие контактов'},
      }
    }
  }
}
</script>
